module.exports = __webpack_public_path__ + "img/balance-bg.3534675f.png";